import { FC } from 'react'
import { TypeIcon } from '@/components/Atoms/Icons/types'

const Icon: FC<TypeIcon> = ({ width = 40, height = 31 }) => {
  return (
    <svg
      width={width}
      height={height}
      style={{
        minHeight: width,
        minWidth: height,
      }}
      viewBox='0 0 40 31'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M20.0078 0.5C30.8288 0.5 39.5078 7.81543 39.5078 18.5361C39.5078 21.5652 39.5063 23.7676 39.2041 25.4043C38.9081 27.0073 38.3385 27.9846 37.25 28.6396C36.1115 29.3248 34.3439 29.698 31.5371 29.8857C28.7453 30.0724 25.0152 30.0723 20.0078 30.0723C15.001 30.0723 11.2691 30.0718 8.47559 29.9004C5.66718 29.728 3.89319 29.3852 2.75 28.7539C1.6617 28.1529 1.10246 27.2644 0.810547 25.8135C0.510317 24.3208 0.507812 22.3092 0.507812 19.5264C0.508019 8.77253 9.22259 0.5 20.0078 0.5Z'
        fill='#DFF0FE'
        stroke='#4788C7'
      />
      <path
        d='M21.5078 19.1328C21.5078 19.9612 20.8362 20.6328 20.0078 20.6328C19.1794 20.6328 18.5078 19.9612 18.5078 19.1328C18.5078 18.3044 19.1794 17.6328 20.0078 17.6328C20.8362 17.6328 21.5078 18.3044 21.5078 19.1328Z'
        fill='#4788C7'
      />
      <line
        x1='19.9374'
        y1='19.191'
        x2='23.5066'
        y2='5.65362'
        stroke='#4788C7'
      />
      <line
        x1='15.5078'
        y1='25.582'
        x2='24.5078'
        y2='25.582'
        stroke='#4788C7'
        strokeWidth='2'
      />
      <path
        d='M19.5292 0.046875L19.5303 4.04688'
        stroke='#4788C7'
      />
      <path
        d='M9.74805 2.74609L11.748 6.2102'
        stroke='#4788C7'
      />
      <path
        d='M3.24234 9.68991L5.81084 11.1711M36.6 28.947L33.4734 27.142'
        stroke='#4788C7'
      />
      <path
        d='M0 19.6807H3.98349M39.0153 19.6807H35.0087'
        stroke='#4788C7'
      />
      <path
        d='M2.4788 28.7603L5.65206 26.9303M36.4751 9.13734L33.4618 10.8715'
        stroke='#4788C7'
      />
      <path
        d='M27.7824 5.71327L29.7783 2.24684'
        stroke='#4788C7'
      />
    </svg>
  )
}

export default Icon
